// src/components/Projects/YouTube/YouTubeEmbed.tsx
import React from "react";

interface YouTubeEmbedProps {
    embedID: string;
}

const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({ embedID }) => (
    <div className="container-iframe">
        <iframe
            src={`https://www.youtube.com/embed/${embedID}?autoplay=1&loop=1&playlist=${embedID}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded youtube"
            className="responsive-iframe"
        />
    </div>
);

export default YouTubeEmbed;

